<!-- src/app/shared/components/week-card-selector/week-card-selector.component.html -->
<div class="week-card-selector d-flex align-items-center gap-3">
    <button class="nav-btn" type="button" aria-label="Previous week" (click)="shiftWindow(-1)">&lt;</button>

    <div class="week-cards d-flex gap-3">
        <div
            *ngFor="let week of visibleWeeks"
            class="week-card"
            role="button"
            tabindex="0"
            [class.active]="week.number === selectedWeekNumber"
            [class.loading]="isWeekLoading(week.number)"
            [attr.aria-pressed]="week.number === selectedWeekNumber"
            (click)="selectWeek(week.number)"
            (keydown.enter)="selectWeek(week.number)"
            (keydown.space)="selectWeek(week.number); $event.preventDefault()">
            <div class="week-card-top">
                <span class="week-label">Week {{ week.number }}</span>
                <span class="adherence-value" *ngIf="!isWeekLoading(week.number)">
                    {{ adherenceFor(week.number)?.chapterAdherence !== null && adherenceFor(week.number)?.chapterAdherence !== undefined
                        ? (adherenceFor(week.number)?.chapterAdherence | number:'1.0-0') + '%'
                        : '—' }}
                </span>
            </div>
            <div class="week-dates">{{ week.dateStart | date:'dd MMM' }} – {{ week.dateEnd | date:'dd MMM' }}</div>
            <div class="adherence-bar">
                <div
                    class="adherence-bar-fill"
                    [style.width.%]="adherenceFor(week.number)?.chapterAdherence ?? 0">
                </div>
            </div>
        </div>
    </div>

    <button class="nav-btn" type="button" aria-label="Next week" (click)="shiftWindow(1)">&gt;</button>
</div>
